(function trackerMedia(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousTrackerMedia = global.NewHomeSource.TrackerMedia;

  /**
   * @constructs NewHomeSource.TrackerMedia
   */
  function TrackerMedia() {
  }

  /**
   * trackCollectionImpressionEvent: tracks the impression event when a collection is viewed.
   * @param {string} viewedCollection collection that was viewed
   */
  TrackerMedia.trackCollectionImpressionEvent = function (viewedCollection) {
    const googleAnalyticsEvent = {
      eventType: 'GA4Event',
      eventName: 'media_views',
      params: {
        click_target: viewedCollection,
        event_type: 'TDV Events',
        currency: 'USD',
        value: '4',
        click_target1: 'On Scroll',
        position: 'On Gallery'
      }
    };
    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: {
        data: googleAnalyticsEvent
      }
    }));
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.TrackerMedia to the previous scripty.
   */
  TrackerMedia.noConflict = function noConflict() {
    global.NewHomeSource.TrackerMedia = previousTrackerMedia;
    return TrackerMedia;
  };

  global.NewHomeSource.TrackerMedia = TrackerMedia;
}(window));
